import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { ThemeService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation/lib/context';

import { RedirectAliases as Alliases, FragmentNames } from '../codegen';
import { ModulesName } from '../definitions';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.REDIRECT })
export default class RedirectControler extends BaseController {

  @OnMount(Alliases.PANEL_REDIRECT)
  onMount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    applicationContext.clearNavigationStack();

    applicationContext.openModule(ModulesName.TECHNICAL_VISIT);
  }
}
